import { Button, Grid, IconButton, Typography } from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer } from "utilize/injectReducer";
import { useInjectSaga } from "utilize/injectSaga";
import { getCounterRequested } from "./actions";
import { AttachCard } from "./components/AttachCard";
import { ImageSlider } from "./components/ImageSlider";
import useStyles from "./style";
import reducer from "../Counter/reducer";
import saga from "../Counter/saga";
import { ActivitySlider } from "./components/ActivitySlider";
import Apis from "constants/Api";
import { useState } from "react";
import ArrowBackIosRounded from "@material-ui/icons/ArrowBackIosRounded";
import { useHistory, useParams } from "react-router";
// import { useParams } from "react-router-dom";
import './style.css'
export default function CounterDetailTest() {
  useInjectReducer({ key: "counter", reducer });
  useInjectSaga({ key: "counter", saga });
  const classes = useStyles();
  const dispatch = useDispatch();
  const [bannerDetail, setBannerDetail] = useState({});
  const history = useHistory();
  const params = useParams();
  const handleBackToCounter = () => {
    history.goBack();
  };
  const [loading, setLoading] = useState(true);
  const CurrentUser = useSelector((state) => state?.main?.currentUser);
  const { g, id } = useParams();
  useEffect(() => {
    if (CurrentUser) {
      setLoading(false);
    }
  }, [CurrentUser]);
  if (loading) return <h1>درحال بارگذاری</h1>;
  if (g !== CurrentUser?.gender?.[0] || id > 12) return <h1 style={{margin:'0 auto'}}>...</h1>;
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className={classes.container}
    >
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.headingContainer}
      >
        <Typography variant="h3" className={classes.heading}>
         {data[g][id - 1].title}
        </Typography>
        <IconButton onClick={handleBackToCounter}>
          <ArrowBackIosRounded />
        </IconButton>
      </Grid>
      
      <div className="eLearnImage">
        <img
          src={
            // "https://backend.ayandehsazan.ir/media/banner_files/%D8%AA%D8%AA.jpg"
            data[g][id - 1].image
          }
          alt="banner"
          className={classes.imageCounter}
          style={{ marginBottom: 0, maxWidth: "none" }}
        />
      </div>

      <Grid
        container
        className={classes.bodyOfCounter}
        style={{ width: "80%" }}
      >
        {/* <div dangerouslySetInnerHTML={{ __html: bannerDetail?.body }} /> */}
        <div style={{width:'100%' }}>{data[g][id - 1].text}</div>
      </Grid>
      {data[g][id - 1].file && (
        <Grid container className={classes.attachContainer}>
          <Grid
            container
            wrap="nowrap"
            alignItems="center"
            style={{ marginBottom: "40px" }}
          >
            <Typography variant="h4" style={{ fontWeight: "bold" }}>
              پیوست
            </Typography>
            <Grid container flex={1} className={classes.horizontalLine2} />
          </Grid>

          <Grid container>
            <AttachCard
              key={1}
              name={data[g][id - 1].fileTitle}
              url={data[g][id - 1].file}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

const noFileText = (
  <strong
    style={{ fontSize: "1.3em", lineHeight: "1.5em", textAlign: "center" }}
  >
    انجمنی عزیز سلام
    <br />
    برای مشاهده عملیات در ابتدای ماه مراجعه کنید
  </strong>
);

const azarText = (
  <p style={{ fontSize: "1.3em", lineHeight: "1.5em" }}>
    کافه ۵۷ یعنی گفت‌وگوی صمیمیِ بچه‌ها درباره انقلاب اسلامی و حال‌وهوای دنیای
    <br />
    امروز! تو این برنامه فقط گوش نمی‌دی؛
    <br />
    🌱 می‌پرسی، 💬 حرف می‌زنی، و 📖 خودت بخشی از بحث می‌شی…
    <br />
    این‌جا مدرسه‌ست، ولی یه جور دیگه؛ یه «کافه فکری» برای حرف‌های مهم.شیوه‌نامه
    برنامه رو بردار و با کافه ۵۷ بیا وسط حرف‌های مهم ✊
  </p>
);

const data = {
  m: [ {
      image: "https://backend.ayandehsazan.ir/media/elearn/m7.jpg",
      text: noFileText,
      file: null,title:'مهر ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m8.jpg",
      text: noFileText,
      file: null,title:'آبان ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m9.jpg",
      text: azarText,
      file: "elearn/azar_cafe57.pdf",
      fileTitle: "شیوه نامه کافه 57",title:'آذر ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m10.jpg",
      text: noFileText,
      file: null,title:'دی ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m11.jpg",
      text: noFileText,
      file: null,title:'بهمن ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m12.jpg",
      text: noFileText,
      file: null,title:'اسفند ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m1.jpg",
      text: noFileText,
      file: null,
      title:'فروردین ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m2.jpg",
      text: noFileText,
      file: null,title:'اردیبهشت ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m3.jpg",
      text: noFileText,
      file: null,title:'خرداد ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m4.jpg",
      text: noFileText,
      file: null,title:'تیر ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m5.jpg",
      text: noFileText,
      file: null,title:'مرداد ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/m6.jpg",
      text: noFileText,
      file: null,title:'شهریور ماه'
    },
   
  ],
  f: [{
      image: "https://backend.ayandehsazan.ir/media/elearn/f7.jpg",
      text: noFileText,
      file: null,title:'مهر ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f8.jpg",
      text: noFileText,
      file: null,title:'آبان ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f9.jpg",
      text: azarText,
      file: "elearn/azar_cafe57.pdf",
      fileTitle: "شیوه نامه کافه 57",title:'آذر ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f10.jpg",
      text: noFileText,
      file: null,title:'دی ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f11.jpg",
      text: noFileText,
      file: null,title:'بهمن ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f12.jpg",
      text: noFileText,
      file: null,title:'اسفند ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f1.jpg",
      text: noFileText,
      file: null,title:'فروردین ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f2.jpg",
      text: noFileText,
      file: null,title:'اردیبهشت ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f3.jpg",
      text: noFileText,
      file: null,title:'خرداد ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f.jpg",
      text: noFileText,
      file: null,title:'تیر ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f5.jpg",
      text: noFileText,
      file: null,title:'مرداد ماه'
    },
    {
      image: "https://backend.ayandehsazan.ir/media/elearn/f6.jpg",
      text: noFileText,
      file: null,title:'شهریور ماه'
    },
    
  ],
};
